// extracted by mini-css-extract-plugin
module.exports = {"svg":"loading_svg__stwix","svgDot":"loading_svgDot__D_q0T","whiteDots":"loading_whiteDots__id_Gs"};